module.exports = __webpack_public_path__ + "img/logo.37ae6dd.png";